<template>
  <svg
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 377.94666 128.32001"
    height="128.32001"
    width="377.94666"
    xml:space="preserve"
    id="svg2"
    version="1.1"
  >
    <g transform="matrix(1.3333333,0,0,-1.3333333,0,128.32)" id="g10">
      <g transform="scale(0.1)" id="g12">
        <!-- _ -->
        <path
          id="path14"
          :style="`fill: ${fillColor};
            fill-opacity: ${fillOpacity};
            fill-rule: nonzero;
            stroke-width: ${(fillWidthPercent / 100) * 24}px;
            stroke: ${fillColor};`"
          d="M 0,0 H 2834.65 V 113.391 H 0 V 0"
        />
        <!-- R -->
        <path
          id="path16"
          :style="`fill: ${fillColor};
            fill-opacity: ${fillOpacity};
            fill-rule: nonzero;
            stroke-width: ${(fillWidthPercent / 100) * 24}px;
            stroke: ${fillColor};`"
          d="M 538.984,743.406 C 526.328,696.355 486.008,667.098 433.855,667.098 H 332.031 l 36.289,135.441 h 120.645 c 22.258,0 39.394,-5.715 47.09,-15.676 9.355,-12.215 5.847,-32.461 2.929,-43.457 z M 682.656,894.199 C 648.398,938.836 592.305,962.41 520.305,962.41 H 238.563 L 159.324,666.648 H 0 V 514.375 H 118.563 L 43.7188,235.051 H 216.184 l 74.226,276.804 h 69.617 L 424.285,235.051 H 613.73 l -76.445,302.488 c 84.512,32.598 146.016,100.879 169.563,188.684 17.449,65.3 8.914,124.937 -24.192,167.976"
        />
        <!-- I -->
        <path
          id="path18"
          :style="`fill: ${fillColor};
            fill-opacity: ${fillOpacity};
            fill-rule: nonzero;
            stroke-width: ${(fillWidthPercent / 100) * 24}px;
            stroke: ${fillColor};`"
          d="m 661.77,235.051 h 172.5 l 194.9,727.359 H 856.688 L 661.77,235.051"
        />
        <!-- T -->
        <path
          id="path24"
          :style="`fill: ${fillColor};
            fill-opacity: ${fillOpacity};
            fill-rule: nonzero;
            stroke-width: ${(fillWidthPercent / 100) * 24}px;
            stroke: ${fillColor};`"
          d="m 1492.62,962.41 h -403.4 l -42.79,-159.871 h 127.08 L 1021.42,235.051 h 172.6 l 152.04,567.488 h 103.72 l 42.84,159.871"
        />
        <!-- T -->
        <path
          id="path26"
          :style="`fill: ${fillColor};
            fill-opacity: ${fillOpacity};
            fill-rule: nonzero;
            stroke-width: ${(fillWidthPercent / 100) * 24}px;
            stroke: ${fillColor};`"
          d="M 1531.45,962.41 1488.61,802.539 H 1605 L 1452.93,235.051 h 172.56 l 152.08,567.488 h 112.88 l 42.84,159.871 h -401.84"
        />
        <!-- A -->
        <path
          id="path22"
          :style="`fill: ${fillColor};
            fill-opacity: ${fillOpacity};
            fill-rule: nonzero;
            stroke-width: ${(fillWidthPercent / 100) * 24}px;
            stroke: ${fillColor};`"
          d="m 2026.38,520.234 107.77,178.809 8.58,-178.809 z m 237.13,442.176 h -131.5 L 1670.32,235.051 h 190.02 l 80.57,131.941 h 206.88 l 9.92,-131.941 h 177.55 l -71.75,727.359"
        />
        <!-- L -->
        <path
          id="path20"
          :style="`fill: ${fillColor};
              fill-opacity: ${fillOpacity};
              fill-rule: nonzero;
              stroke-width: ${(fillWidthPercent / 100) * 24}px;
              stroke: ${fillColor};`"
          d="M 2570.08,394.949 2722.17,962.41 H 2549.64 L 2354.79,235.051 h 479.86 v 159.898 h -264.57"
        />
      </g>
    </g>
  </svg>
</template>
<script setup lang="ts">
import { useApplicationStore } from "@/store";
import anime from "animejs";
import { computed, ref, watch } from "vue";

const props = defineProps({
  noFill: {
    required: false,
    default: true,
    type: Boolean,
  },
});

const fillOpacity = ref(0.1);
const fillWidthPercent = ref(100);

watch(
  () => props.noFill,
  () => {
    anime({
      targets: fillOpacity,
      value: props.noFill ? 0.1 : 1.1,
      easing: "easeInOutQuad",
      round: false,
      duration: 400,
    });
    anime({
      targets: fillWidthPercent,
      value: props.noFill ? 100 : 0,
      easing: "easeInOutQuad",
      round: 1,
      duration: 400,
    });
  }
);

const applicationStore = useApplicationStore();

const fillColor = computed(() => {
  if (applicationStore.theme === "dark") return "#ffffff";
  return "#231f20";
});
</script>
<style lang="scss" scoped></style>
